import { FC, PropsWithChildren } from 'react'

export const HeaderWrapper: FC<PropsWithChildren> = ({ children }) => (
  <header className="fixed z-50 flex w-screen items-center border-b border-b-light bg-default print:hidden">
    {children}
  </header>
)
